"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentTime = void 0;
var player_base_1 = require("@24i/player-base");
function getContentTime(advertisements, mediaTime) {
    if (advertisements.length === 0)
        return mediaTime;
    var adjustedTime = mediaTime;
    advertisements.forEach(function (advertisement) {
        if (advertisement.type === player_base_1.ISourceTimelineEventType.ADVERTISEMENT) {
            if (mediaTime >= advertisement.end) {
                adjustedTime -= advertisement.end - advertisement.start;
            }
            else if (mediaTime >= advertisement.start) {
                adjustedTime -= mediaTime - advertisement.start;
            }
        }
    });
    return adjustedTime;
}
exports.getContentTime = getContentTime;
//# sourceMappingURL=getContentTime.js.map